module.exports = __webpack_public_path__ + "media/icons/switch_green@2x-54f8e1a1.png";